import { AutofocusDirective } from '../../../../../../shared/directive/autofocus.directive';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  model,
} from '@angular/core';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerMaskDirective } from '@anihis/shared/src/shared/directive/mat-datepicker-mask.directive';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';
import isEqual from 'lodash/isEqual';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';
import {
  getMaxBirthDate,
  getMinAnimalBirthDate,
} from '@anihis/shared/src/validators/birth-date.validators';

@Component({
  selector: 'anihis-procedure-under-general-anesthesia',
  standalone: true,
  imports: [
    AutofocusDirective,
    CommonModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepickerMaskDirective,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  templateUrl: './procedure-under-general-anesthesia.component.html',
  styleUrl: './procedure-under-general-anesthesia.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcedureUnderGeneralAnesthesiaComponent
  extends FormBaseComponent
  implements OnInit
{
  minDate = getMinAnimalBirthDate();
  today = getMaxBirthDate();

  @Output() formChange = new EventEmitter<any>();
  readonly checked = model(false);
  override ngOnInit() {
    this.form = this.fb.group({
      recommendedHematology: [false],
      recommendedEkg: [false],
      recommendedBiopsy: [false],
      recommendedBiochemistry: [false],
      recommendedEho: [false],
      recommendedEndoscopy: [false],
      recommendedRtg: [false],
      recommendedMri: [false],
      recommendedUrineAnalysis: [false],
      recommendedOther: [''],

      performedHematology: [false],
      performedEkg: [false],
      performedBiopsy: [false],
      performedBiochemistry: [false],
      performedEho: [false],
      performedEndoscopy: [false],
      performedRtg: [false],
      performedMri: [false],
      performedUrineAnalysis: [false],
      performedOther: [''],

      interventionProcedure: [''],
      notesInstructions: [''],
      costEstimationMentionedProceduresFrom: [null, [Validators.min(0)]],
      costEstimationMentionedProceduresTo: [null, [Validators.min(0)]],
      additionalCostFrom: [null, [Validators.min(0)]],
      additionalCostTo: [null, [Validators.min(0)]],
      date: [null],
      veterinarianName: [''],
    });

    this.form.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(isEqual))
      .subscribe((value) => {
        this.formChange.emit(value);
      });
  }

  clearForm() {
    this.form.reset();
  }

  handlePathClick(pathNumber: number) {
  }
}
